/* Little Sonny theme — vanilla JS interactions (drawers, cart, carousels, toasts) */
(function () {
  'use strict';

  var LS = (window.LittleSonny = window.LittleSonny || {});

  /* ---------------------------------------------------------------- money */
  function formatMoney(cents) {
    var format = LS.moneyFormat || '£{{amount}}';
    function defaultTo(value, def) {
      return value == null || value === '' ? def : value;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var value = '';
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    var placeholder = match ? match[1] : 'amount';
    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  LS.formatMoney = formatMoney;

  /* --------------------------------------------------------------- toasts */
  function toast(message, description) {
    var host = document.getElementById('ls-toasts');
    if (!host) return;
    var el = document.createElement('div');
    el.className =
      'bg-background border border-border shadow-lg px-4 py-3 transition-all duration-300 opacity-0 translate-y-2';
    el.innerHTML =
      '<p class="type-small font-medium"></p>' +
      (description ? '<p class="type-caption text-muted-foreground mt-1"></p>' : '');
    el.querySelector('p').textContent = message;
    if (description) el.querySelectorAll('p')[1].textContent = description;
    host.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.remove('opacity-0', 'translate-y-2');
    });
    setTimeout(function () {
      el.classList.add('opacity-0', 'translate-y-2');
      setTimeout(function () {
        el.remove();
      }, 300);
    }, 4000);
  }
  LS.toast = toast;

  /* -------------------------------------------------------------- drawers */
  function openDrawer(panel, overlay) {
    if (!panel) return;
    panel.classList.remove('translate-x-full');
    if (overlay) overlay.classList.remove('opacity-0', 'pointer-events-none');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(panel, overlay) {
    if (!panel) return;
    panel.classList.add('translate-x-full');
    if (overlay) overlay.classList.add('opacity-0', 'pointer-events-none');
    document.body.style.overflow = '';
  }

  var cartPanel, cartOverlay, menuPanel, menuOverlay;

  function initDrawers() {
    cartPanel = document.querySelector('[data-cart-panel]');
    cartOverlay = document.querySelector('[data-cart-overlay]');
    menuPanel = document.querySelector('[data-menu-panel]');
    menuOverlay = document.querySelector('[data-menu-overlay]');

    document.addEventListener('click', function (event) {
      var openCart = event.target.closest('[data-cart-open]');
      if (openCart) {
        event.preventDefault();
        closeDrawer(menuPanel, menuOverlay);
        openDrawer(cartPanel, cartOverlay);
        return;
      }
      if (event.target.closest('[data-cart-close]') || event.target.closest('[data-cart-overlay]')) {
        closeDrawer(cartPanel, cartOverlay);
        return;
      }
      if (event.target.closest('[data-menu-open]')) {
        openDrawer(menuPanel, menuOverlay);
        return;
      }
      if (event.target.closest('[data-menu-close]') || event.target.closest('[data-menu-overlay]')) {
        closeDrawer(menuPanel, menuOverlay);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer(cartPanel, cartOverlay);
        closeDrawer(menuPanel, menuOverlay);
      }
    });
  }
  LS.openCart = function () {
    openDrawer(cartPanel, cartOverlay);
  };

  /* ------------------------------------------------------------ cart core */
  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    var footer = document.querySelector('[data-cart-footer]');
    if (!body) return;

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });
    document.querySelectorAll('[data-cart-count-text]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="flex items-center justify-center py-16"><div class="text-center">' +
        '<p class="type-small text-muted-foreground">Your basket is empty</p></div></div>';
      if (footer) footer.innerHTML = '';
      return;
    }

    body.innerHTML = cart.items
      .map(function (item, index) {
        var line = index + 1;
        var img = item.image
          ? '<img src="' +
            item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') +
            '" alt="" class="w-full h-full object-cover" loading="lazy">'
          : '';
        var variant =
          item.variant_title && item.variant_title.indexOf('Default') === -1
            ? '<p class="type-small text-muted-foreground mt-0.5">' + item.variant_title + '</p>'
            : '';
        return (
          '<div class="flex gap-4 border-b border-border py-4">' +
          '<div class="w-20 h-24 bg-secondary flex-shrink-0 overflow-hidden">' + img + '</div>' +
          '<div class="flex-1 min-w-0">' +
          '<h4 class="type-h3 truncate">' + item.product_title + '</h4>' + variant +
          '<p class="type-small font-display mt-1">' + formatMoney(item.final_line_price) + '</p>' +
          '<div class="inline-flex items-center border border-border mt-2">' +
          '<button type="button" class="h-7 w-7 flex items-center justify-center hover:bg-secondary transition-colors" data-qty-change data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
          '<span class="type-small font-display w-7 text-center">' + item.quantity + '</span>' +
          '<button type="button" class="h-7 w-7 flex items-center justify-center hover:bg-secondary transition-colors" data-qty-change data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div></div>' +
          '<button type="button" class="h-6 w-6 flex-shrink-0 flex items-center justify-center hover:opacity-60 transition-opacity" data-qty-change data-line="' + line + '" data-qty="0" aria-label="Remove item">&times;</button>' +
          '</div>'
        );
      })
      .join('');

    if (footer) {
      footer.innerHTML =
        '<div class="border-t border-border pt-4 space-y-4 flex-shrink-0">' +
        '<div class="type-small flex justify-between"><span class="type-eyebrow">Subtotal</span>' +
        '<span class="font-display">' + formatMoney(cart.total_price) + '</span></div>' +
        '<p class="type-small text-muted-foreground">Shipping &amp; taxes calculated at checkout</p>' +
        '<form action="' + LS.routes.cart + '" method="post">' +
        '<button type="submit" name="checkout" class="type-button w-full h-12 bg-primary text-primary-foreground border border-primary inline-flex items-center justify-center gap-2 btn-swipe">' +
        '<span>Checkout — ' + formatMoney(cart.total_price) + '</span></button></form></div>';
    }
  }
  LS.renderCart = renderCart;

  function refreshCart() {
    return fetch(LS.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }
  LS.refreshCart = refreshCart;

  LS.addToCart = function (variantId, quantity) {
    return fetch(LS.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add to basket');
          return data;
        });
      })
      .then(function () {
        return refreshCart();
      })
      .then(function (cart) {
        LS.openCart();
        if (window.fbq) window.fbq('track', 'AddToCart');
        if (window.ttq) window.ttq.track('AddToCart');
        return cart;
      })
      .catch(function (error) {
        toast('Could not add to basket', error.message);
        throw error;
      });
  };

  function initCartActions() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-qty-change]');
      if (!button) return;
      event.preventDefault();
      fetch(LS.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(button.dataset.line), quantity: Number(button.dataset.qty) })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () { toast('Could not update your basket'); });
    });
  }

  /* -------------------------------------------------------- announcements */
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    var items = bar.querySelectorAll('[data-announcement-item]');
    if (!items.length) return;
    var index = 0;

    function show(next) {
      index = (next + items.length) % items.length;
      items.forEach(function (item, i) {
        var active = i === index;
        item.classList.toggle('opacity-100', active);
        item.classList.toggle('opacity-0', !active);
        item.classList.toggle('pointer-events-none', !active);
        if (active) {
          item.removeAttribute('aria-hidden');
          item.setAttribute('tabindex', '0');
        } else {
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }

    var timer = setInterval(function () { show(index + 1); }, 4000);
    function manual(step) {
      clearInterval(timer);
      show(index + step);
      timer = setInterval(function () { show(index + 1); }, 4000);
    }
    var prev = bar.querySelector('[data-announcement-prev]');
    var next = bar.querySelector('[data-announcement-next]');
    if (prev) prev.addEventListener('click', function () { manual(-1); });
    if (next) next.addEventListener('click', function () { manual(1); });

    // Collapse on scroll on mobile only, matching the site behaviour
    function onScroll() {
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var collapsed = isMobile && window.scrollY > 20;
      bar.classList.toggle('max-h-0', collapsed);
      bar.classList.toggle('max-h-9', !collapsed);
      bar.classList.toggle('border-b-0', collapsed);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ------------------------------------------------------------ carousels */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      if (!track) return;
      function step() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      }
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ------------------------------------------------------ smooth anchors */
  function initAnchors() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-scroll-to]');
      if (!link) return;
      var target = document.querySelector(link.dataset.scrollTo);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initDrawers();
    initCartActions();
    initAnnouncementBar();
    initCarousels();
    initAnchors();
  });
})();
